import { useCallback, useContext, useMemo, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { convertReactSelectObjectToValue } from '../../../../../../utils/reporting/config'
import GenericTable from '../table/GenericTable'
import { ReportingContext } from '../../../../../wrappers/ReportingContext'
import { SelectColumnsContext } from './SelectColumnsContext'
import EmptyTitleHeader from '../table/TitleHeader'

const AvailableColumns = [
    {
        Header: 'In SELECT?',
        accessor: 'inSelect',
        Cell: ({ value }) => value,
    },
    {
        Header: 'Source.Column',
        accessor: 'sourceColumn',
        Cell: ({
            cell,
            value: initialValue,
            row: { index },
            column: { id, accessor },
        }) => {
            // const { control } = useFormContext()
            return (
                initialValue && (
                    <span>
                        {initialValue.split('.')[0]}.
                        <b>{initialValue.split('.')[1]}</b>
                    </span>
                )
            )
        },
    },
    {
        Header: 'Column Type',
        accessor: 'columnType',
        Cell: ({
            cell,
            value: initialValue,
            row: { index },
            column: { id, accessor },
        }) => {
            // const { control } = useFormContext()
            return initialValue
        },
    },
]

const AvailableColumnsTable = () => {
    const { reportSelectOptions } = useContext(ReportingContext)
    const {
        leftTableHighlights,
        setLeftTableHighlights,
        setLeftTableData,
        rightTableData,
    } = useContext(SelectColumnsContext)

    const handleFilteredRowsChange = useCallback(
        (rowsInfo) => {
            setLeftTableData(rowsInfo.filteredRows)
        },
        [setLeftTableData]
    )

    const selectedDataSourceColumns = useMemo(
        () =>
            reportSelectOptions && reportSelectOptions.selectedDataSourceColumns
                ? reportSelectOptions.selectedDataSourceColumns
                : [],
        [reportSelectOptions]
    )

    const selectedDataSources = useMemo(() => {
        return reportSelectOptions && reportSelectOptions.selectedDataSources
            ? reportSelectOptions.selectedDataSources
            : []
    }, [reportSelectOptions])

    const fields = useMemo(() => {
        const fieldList = []
        selectedDataSources.forEach((x) => {
            const fieldGroup = selectedDataSourceColumns
                .filter((f) => f.TABLE_NAME === x.value)
                .map((col, i) => {
                    const tableName = x.alias || col.TABLE_NAME
                    const sourceColumn = `${tableName}.${col.COLUMN_NAME}`
                    const inSelectValue = rightTableData?.some(
                        (item) => item.sourceColumn === sourceColumn
                    )
                        ? 'Yes'
                        : 'No'

                    return {
                        id: `${tableName}[${i}]`,
                        inSelect: inSelectValue,
                        sourceColumn,
                        columnType: col.DATA_TYPE_DISPLAY,
                    }
                })
            fieldList.push(...fieldGroup)
        })
        return fieldList
    }, [selectedDataSourceColumns, selectedDataSources, rightTableData])

    useEffect(() => {
        setLeftTableData(fields)
    }, [fields, setLeftTableData])

    return fields && fields.length ? (
        <GenericTable
            columns={AvailableColumns}
            fields={fields}
            tableHeight={'52vh'}
            tableTile={'Available Columns'}
            viewOnly={false}
            // onHightlight={onHightlight}
            onHightlight={setLeftTableHighlights}
            highlightedRows={leftTableHighlights}
            filterable={true}
            onFilteredRowsChange={handleFilteredRowsChange}
        />
    ) : (
        <EmptyTitleHeader fields={fields} tableTile={'Available Columns'} />
    )
}

export default AvailableColumnsTable
